import React, { useEffect, useState } from 'react';
import AppPage from '../common/AppPage';
import AttrChart from './AttrChart';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';

function StatsDetailPage() {
  const [loading2, setLoading2] = useState(true);
  const [stats2, setStats2] = useState(null as any);
  const navigate = useNavigate();
  const params = useParams(); 
  const race = params.race as string;
  const profession = params.profession as string;
  const homeland = params.homeland as string;
  const homelandDisplay = homeland.replace(' Trolloc', '').replace('the ', '');

  const roundNumber = (x: number) => parseFloat((x).toFixed(x < 1 ? 3 : 1));

  useEffect(() => {
    setLoading2(true);
    setStats2(null);
    const url = `https://wotcodeapi.azurewebsites.net/api/stats/aggregate?race=${race}&class=${profession}&homeland=${homeland}`;
    fetch(url).then(resp => resp.json()).then(result => {
      result = result.length ? result[0] : null;
      result.homelandDisplay = result.homeland.replace(' Trolloc', '').replace('the ', '');
      result.strength.items.forEach((x: any) => x.probability = roundNumber(x.probability * 100));
      result.intelligence.items.forEach((x: any) => x.probability = roundNumber(x.probability * 100));
      result.willpower.items.forEach((x: any) => x.probability = roundNumber(x.probability * 100));
      result.dexterity.items.forEach((x: any) => x.probability = roundNumber(x.probability * 100));
      result.constitution.items.forEach((x: any) => x.probability = roundNumber(x.probability * 100));
      result.statsum.items.forEach((x: any) => x.probability = roundNumber(x.probability * 100));
      setStats2(result);
      setLoading2(false);
    });
  }, [race, profession, homeland]);

  const handleBackClick = () => {
    navigate('/oldstats');
  };

  const detailView = () => {
    return (
      <>
        <div className="d-flex align-items-center">
          <h5 className="mb-1 me-2">{homelandDisplay} {race} {profession}</h5> {stats2 && <span className="text-muted small">({stats2.count})</span>}
        </div>

        <button className="small d-block btn btn-link text-decoration-none p-0 mb-4" onClick={() => handleBackClick()}>&lt; Back</button>

        {stats2 && <div className="row">
          <div className="col-12 col-lg-4 mb-4">
            <p className="mb-2">Physicals</p>
            <AttrChart payload={stats2} attributes={['strength', 'dexterity', 'constitution']} type="physicals" race={race}/>
          </div>
          <div className="col-12 col-lg-4 mb-4">
            <p className="mb-2">Mentals</p>
            <AttrChart payload={stats2} attributes={['intelligence', 'willpower']} type="mentals" race={race}/>
          </div>
          <div className="col-12 col-lg-4 mb-4">
            <p className="mb-2">Statsum</p>
            <AttrChart payload={stats2} attributes={['statsum']} type="statsum" race={race}/>
          </div>
        </div>}
        
        {loading2 && (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        )}

        {!loading2 && stats2 && (
          <div>
            <p className="mb-2">Best Recorded Stats</p>
            <div className="overflow-auto mb-4" style={{ maxHeight: '11rem' }}>
              <table className="table table-striped small m-0">
                <thead className="bg-dark" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <tr className="smaller">
                    <th className="py-1">Strength</th>
                    <th className="py-1">Intelligence</th>
                    <th className="py-1">Willpower</th>
                    <th className="py-1">Dexterity</th>
                    <th className="py-1">Constitution</th>
                    <th className="py-1">Sum</th>
                    <th className="py-1">Count</th>
                    <th className="py-1">Recorded</th>
                  </tr>
                </thead>
                <tbody>
                  {stats2.best.map((item: any, index: number) => (
                    <tr key={index}>
                      <td>{item.strength}</td>
                      <td>{item.intelligence}</td>
                      <td>{item.willpower}</td>
                      <td>{item.dexterity}</td>
                      <td>{item.constitution}</td>
                      <td>{item.statSum}</td>
                      <td>{item.count}</td>
                      <td>{moment(item.submitted).format('MM/DD/YYYY')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="mb-2">Recent Recorded Stats</p>
            <div className="overflow-auto mb-0" style={{ maxHeight: '11rem' }}>
              <table className="table table-striped small m-0">
                <thead className="bg-dark" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <tr className="smaller">
                    <th className="py-1">Strength</th>
                    <th className="py-1">Intelligence</th>
                    <th className="py-1">Willpower</th>
                    <th className="py-1">Dexterity</th>
                    <th className="py-1">Constitution</th>
                    <th className="py-1">Sum</th>
                    <th className="py-1"><span className="invisible">Count</span></th>
                    <th className="py-1">Recorded</th>
                  </tr>
                </thead>
                <tbody>
                  {stats2.recent.map((item: any, index: number) => (
                    <tr key={index}>
                      <td>{item.strength}</td>
                      <td>{item.intelligence}</td>
                      <td>{item.willpower}</td>
                      <td>{item.dexterity}</td>
                      <td>{item.constitution}</td>
                      <td>{item.statSum}</td>
                      <td><span className="invisible">{item.count}</span></td>
                      <td>{moment(item.submitted).format('MM/DD/YYYY')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </>);
  };

  return (
    <AppPage pageClass="scripts-page">
      <div className="scripts">
        {detailView()}
      </div>

    </AppPage>
  );
}

export default StatsDetailPage;